import { render, staticRenderFns } from "./SanityModule.vue?vue&type=template&id=6fedbca3"
import script from "./SanityModule.vue?vue&type=script&lang=js"
export * from "./SanityModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports